<template>
  <div id="search">
    <div class="header-nav">
      <a
        class="tab-item hidden-xs-only"
        :class="{ active: i == $store.state.newsTabI }"
        v-for="(v, i) in menu_list"
        :key="i"
        @click="tabHandle(v)"
        >{{ v.cnName }}</a
      >
    </div>
    <div class="nav-wrap">
      <div class="nav-title">"{{ text }}"的搜索结果</div>
    </div>
    <div class="search-wrap">
      <div class="flex search-content hidden-xs-only">
        <el-input
          class="search-text"
          clearable
          placeholder="搜索"
          @keyup.enter.native="loadData"
          v-model="searchText"
        ></el-input>
        <div class="search-icon" @click="loadData">
          <!-- <i class="el-input__icon el-icon-search"></i> -->
          <img alt="search" class="detail-icon" src="../../assets/search-icon-detail.png">
        </div>
      </div>
      <div class="flex order-time">
          <div class="time-total">
            约{{total}}个搜索结果({{timeTotal/1000}}秒)
          </div>
          <div class="time-order">
            <span class="time-total">日期排序：</span>
            <el-select @change="changeOrder" style="width: 80px;" v-model="orderValue" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.lable"
                    :value="item.value">
                  </el-option>
            </el-select>
            
          </div>
      </div>
      <div @click="goArticle(v.id)" class="search-item hidden-xs-only" v-for="(v) in searchList" :key="v.createTime" >
          <h2 class="hidden-xs-only title">{{v.title}}</h2>
          <div class="wangzhi">http://www.rcpjfoundation.com/#/article/{{v.id}}</div>
          <div class="flex search-item-text">
            <img class="bg-img" :src="v.imgUrl || '/a'" @error="imgError('/img/newimg.png')">
            <div class="wangzhi described txt-line-2">{{v.described}}</div>
          </div>
      </div>
      <div class="hide-pc">
          <div class="search-item" @click="goArticle(v.id)" v-for="(v) in searchList" :key="v.createTime" >
            <div class="flex search-item-text">
              <img class="bg-img" :src="v.imgUrl || '/a'" @error="imgError('/img/newimg.png')">
              <div>
                <div class="wangzhi txt-line-3">{{v.title}}</div>
                <div class="des txt-line-2">{{v.described}}</div>
              </div>
              
            </div>
          </div>
      </div>
      
      <div class="project-pagination-wrap">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :pager-count="5"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getColumns } from "@/api/home";
import {searchArticleList} from '@/api/news'
import {imgError} from '@/assets/utility'

export default {
  data() {
    return {
      title: "",
      menu_list: [],
      pageSize: 10,
      currentPage: 1,
      searchList: [],
      searchText: '',
      text: '',
      total: 0,
      timeTotal: 0,
      orderValue: 0,
      showText: true,
      options: [
        {value: 0,lable: '正序'},
        {value: 1,lable: '倒序'},
      ]
    };
  },
  mounted() {
    this.title = this.$store.state.newsTabI ? "视频" : "新闻";
    this.$store.commit("setCurrentMenuI", 5);
    this.searchText = this.$route.params.searchValue
    this.loadData()
    getColumns("1286461502767104").then((res) => {
      if (res) {
        this.menu_list = res[0].subList;
      }
    });
  },
  methods: {
    tabHandle(v) {
      this.title = v.cnName;
      let route = v.targetUrl.replace("/", "");
      route = route === "news" ? "" : route;
      this.$router.push({
        path: `/media/${v.topId}/` + route,
        query: {
          colId: v.colId,
        },
      });
    },
     imgError(pUrl) {
      imgError(pUrl)
    },
    loadData () {
      this.text = this.searchText
      searchArticleList({pageSize:this.pageSize,pageNum:this.currentPage,text: this.searchText,sort: this.orderValue}).then(res => {
          this.searchList = res.rows
          this.total = Number(res.total)
          this.timeTotal = res.time
          this.showText = true
      })
    },
    changeOrder () {
      this.loadData()
    },
    handleCurrentChange (e) {
      this.currentPage = e
      this.loadData(this.colid)
    },
    goArticle (id) {
      this.$router.push(`/article/${id}`)
    },
    clearText () {
      this.showText = false
    }
  },
  watch: {
    $route: {
          handler() {
            this.searchText = this.$route.params.searchValue
            this.loadData()
        },
        deep: true,
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-wrap {
  width: 80%;
  .nav-title{
    border-bottom: none;
    height: 60px;
    line-height: 60px;
    margin-top: rem(30);
  }
  
}
.search-wrap {
  width: 80%;
  padding: 0 rem(75);
  .search-content {
    justify-content: space-between;
    margin-top: 10px;
    .search-text {
      font-size: rem(15);
      margin-right: rem(50)
    }
    .detail-icon {
      position: relative;
      top:3px;
    }
    .search-icon {
      width: rem(95);
      background: #03a762;
      text-align: center;
      cursor: pointer;
      i {
        font-size: rem(10);
        color: #fff;
        transform: scale(1.6);
      }
    }
  }
  .order-time {
    justify-content: space-between;
    border-bottom: 1px solid #bfbfbf;
    margin-bottom: 60px;
    .time-total {
      flex: 1;
      height: 60px;
      line-height: 60px;
      color:#c6c6c6;
      font-size: rem(15);
    }
    .time-order {
      text-align: right;
      height: 60px;
      line-height: 60px;
      .slect-wrap {
        width: rem(300);
      }
    }
  }
  
}
@media only screen and (min-width: 768px) {
  .hide-pc {
    display: none;
  }
  .ma-top {
    margin-top: rem(50);
  }
  .search-item {
    margin-bottom: 40px;
    cursor: pointer;
    h2 {
      margin: 0;
      padding-bottom: rem(15);
      font-size: rem(34)
    }
    .wangzhi {
      color: #808080;
      font-size: rem(24);
    }
    .described {
      height: 90%;
    }
    .search-item-text {
      margin-top: 20px;
    }
    .flex {
      .bg-img {
        width: rem(148);
        height:rem(80);
        margin-right:20px;
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .hide-pc {
    display: block;
  }
  .header-nav {
    height: .6rem;
  }
  .nav-wrap .nav-title {
    height: .6rem;
    line-height: .6rem;
  }
  .search-wrap .order-time {
    margin-bottom: 30px;
  }
  .search-item {
    padding-bottom: 20px;
    border-bottom: 1px solid #bfbfbf;
    .search-item-text {
      margin-top: 20px;
      
      .des {
        font-size: .12rem;
        color: #808080;
      }
    }
    .wangzhi {
      font-size: .3rem;
      margin-bottom: .2rem;
    }

    .flex {
      .bg-img {
        width: 3rem;
        margin-right:20px;
      }
    }
  }
}
</style>
